export default __webpack_public_path__ + "static/media/song1.ee214f5a.jpeg";